import app from '../../config/configApp';
import Vue3Signature from "vue3-signature";
import CKEditor from "@ckeditor/ckeditor5-vue";
import Pusher from 'pusher-js';

window.Pusher = Pusher;

app.use(Vue3Signature);
app.use(CKEditor);
